/*& Models/States/InAppBrowser
	# IABState
*/
export class IABState {
	public url = ''

	update(data: any): IABState {
		this.url = data.url

		return this
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/state/iabState.ts